import React from "react"
import { Container, Grid, Button, Icon } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Introduction.css"

export const Introduction = ({ continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered>
      <Grid.Row style={{ paddingBottom: "0px" }}>
        <Grid.Column textAlign="center">
          <h2 className="AccountIntroduction__Heading">Lets Get Organized.</h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px" }}>
        <Grid.Column
          className="AccountIntroduction__Description"
          width={14}
          textAlign="center"
        >
          <p className="AccountIntroduction__DescriptionText">
            Making smarter financial choices gets easier when you can see your
            complete money picture.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered columns={3}>
        <Grid.Column>
          <div className="Introduction_SectionTitle">Easy</div>
          <p className="Introduction_SectionText">
            Easily see all your accounts in one secure spot:
          </p>
          <div>
            <ul
              className="OrganizeIntroduction__List"
              style={{ paddingLeft: "0" }}
            >
              <li>
                <span>
                  <span className="Introduction_ListItem">
                    <Icon name="chevron right" size="small" />
                    Bank Accounts + Credit Cards
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span className="Introduction_ListItem">
                    <Icon name="chevron right" size="small" />
                    Investments + Insurance
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span className="Introduction_ListItem">
                    <Icon name="chevron right" size="small" />
                    Real Estate + Loans
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="Introduction_SectionTitle">Smart</div>
          <p className="Introduction_SectionText">
            Use artificial intelligence to optimize your financial choices.
          </p>
          <div>
            <ul className="OrganizeIntroduction__List">
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  Built by MIT-trained PhDs
                </span>
              </li>
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  World recognized data scientists
                </span>
              </li>
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  Team experienced in managing billions
                </span>
              </li>
            </ul>
          </div>
        </Grid.Column>
        <Grid.Column>
          <div className="Introduction_SectionTitle">Trusted</div>
          <p className="Introduction_SectionText">
            As a fiduciary, we're committed to putting your best interest first.
          </p>
          <div>
            <ul className="OrganizeIntroduction__List">
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  SEC-registered investment adviser (such registration does not
                  imply a certain level of skill or training)
                </span>
              </li>
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  Team with 20+ years of financial services experience
                </span>
              </li>
              <li>
                <span>
                  <Icon name="chevron right" size="small" />
                  Platform has multi-layer data security and encryption
                </span>
              </li>
            </ul>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column className="Introduction_VideoSection" align="center">
          <div className="AccountIntroduction__VideoHolder">
            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
              <iframe
                title="Introduction Video"
                src="https://player.vimeo.com/video/238647212?title=0&byline=0&portrait=0"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%"
                }}
                frameBorder="0"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen={true}
              />
            </div>
            <script src="https://player.vimeo.com/api/player.js" />
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="Description_Div" textAlign="center">
        <Grid.Column>
          <div className="Description_Title">
            Take control of your financial life&mdash; it's easier than you
            think.{" "}
          </div>
          <p className="Introduction_Description_Text">
            Personalized, independent advice in your best interest with clear
            explanations and turn-by-turn directions.{" "}
          </p>
          <div
            className="AccountIntroduction__Skip"
            style={{ textAlign: "center" }}
          >
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Introduction_Start_Button"
              >
                Get Started!
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)
